import { useState, useEffect, useCallback } from "react";
import { motion, AnimatePresence } from "framer-motion";
import {
  Star,
  Wifi,
  Tv,
  Wind,
  Bath,
  Waves,
  MapPin,
  ExternalLink,
  Home,
  UtensilsCrossed,
  Coffee,
  Shirt,
  Flame,
  ChevronLeft,
  ChevronRight,
  Mountain,
  Baby,
  X,
  Grid3X3,
} from "lucide-react";
import AnimatedSection from "./AnimatedSection";
// airbnb1 – all 19 images
import a1_01 from "../../assets/portugal/airbnb1/03aa43b0-1010-49d1-84d1-8341a8771108.jpeg";
import a1_02 from "../../assets/portugal/airbnb1/05da3b94-8613-443a-9a57-29765ca25d22.jpeg";
import a1_03 from "../../assets/portugal/airbnb1/09427ea0-e9c6-4181-9538-3ace5a0d60ae.jpeg";
import a1_04 from "../../assets/portugal/airbnb1/18b3e46f-28ab-4391-898c-8ab59c2ddb72.jpeg";
import a1_05 from "../../assets/portugal/airbnb1/277efcd7-ed35-4b61-b025-90f3a8a2759b.jpeg";
import a1_06 from "../../assets/portugal/airbnb1/50c3f049-1c4d-4f9c-853f-dbf950be8e4e.jpeg";
import a1_07 from "../../assets/portugal/airbnb1/53c56b5b-f7e1-4483-a1e3-34a3c7a7b9e9.jpeg";
import a1_08 from "../../assets/portugal/airbnb1/82d6b661-f631-4577-aa3f-a0e0ee21e85f.jpeg";
import a1_09 from "../../assets/portugal/airbnb1/83fce1d1-77b8-4df9-a109-51f60a2549fd.jpeg";
import a1_10 from "../../assets/portugal/airbnb1/9487c77c-f54f-448c-99fb-7515f7961fe6.jpeg";
import a1_11 from "../../assets/portugal/airbnb1/98cc5026-9120-4579-b594-bbb9fd749473.jpeg";
import a1_12 from "../../assets/portugal/airbnb1/ab71efe8-d373-4843-b671-95c6a719f38f.jpeg";
import a1_13 from "../../assets/portugal/airbnb1/ad4bfcca-0b20-4d30-8dc0-eba1d10db717.jpeg";
import a1_14 from "../../assets/portugal/airbnb1/aee5f66c-1f77-4f73-83cb-411bf5d3e643.jpeg";
import a1_15 from "../../assets/portugal/airbnb1/bcb99db3-c2af-46c3-8827-34b39e78f310.jpeg";
import a1_16 from "../../assets/portugal/airbnb1/c6ffac4d-80b0-42e8-9def-43fd52bcccaf.jpeg";
import a1_17 from "../../assets/portugal/airbnb1/ce394b48-51c0-4820-9116-d4d3a15679d1.jpeg";
import a1_18 from "../../assets/portugal/airbnb1/d590a30d-f406-4af1-9d7f-144ba48fa9ef.jpeg";
import a1_19 from "../../assets/portugal/airbnb1/d87ea1aa-5e39-4d8c-a786-00dd3f7f980b.jpeg";
// airbnb2 – all 24 images
import a2_01 from "../../assets/portugal/airbnb2/22f4e52f-bcf6-42be-98b1-3e22f60ce9e5.jpeg";
import a2_02 from "../../assets/portugal/airbnb2/29800a5e-c934-4ee9-8d95-a0c6d5e7cdea.jpeg";
import a2_03 from "../../assets/portugal/airbnb2/29e6b03c-82e9-457c-9070-c6a4196e82e2.jpeg";
import a2_04 from "../../assets/portugal/airbnb2/2ba3f468-2fff-4741-9bc5-31cc92c996fa.jpeg";
import a2_05 from "../../assets/portugal/airbnb2/2c32f6d3-8539-4511-bb81-f40cdb3785c1.jpeg";
import a2_06 from "../../assets/portugal/airbnb2/3c262576-9376-4114-9104-b597ed7bc3ac.jpeg";
import a2_07 from "../../assets/portugal/airbnb2/4ac33509-1e01-411e-9012-a4655766c563.jpeg";
import a2_08 from "../../assets/portugal/airbnb2/527ab28c-3ca5-4237-8007-303d6e916082.jpeg";
import a2_09 from "../../assets/portugal/airbnb2/5590c1f1-d4c5-4d40-b755-3566789e5676.jpeg";
import a2_10 from "../../assets/portugal/airbnb2/63abbae4-5e98-480d-ac9c-98e6b86b2076.jpeg";
import a2_11 from "../../assets/portugal/airbnb2/7b8046c5-88d3-444f-8a66-8cf8e91b9392.jpeg";
import a2_12 from "../../assets/portugal/airbnb2/8bd77058-263e-4a72-b805-03cf3cd20a20.jpeg";
import a2_13 from "../../assets/portugal/airbnb2/910b80b8-c72a-46c7-aba3-9e18261cc46c.jpeg";
import a2_14 from "../../assets/portugal/airbnb2/9143c94b-31ad-46ef-8479-90443a52dc0e.jpeg";
import a2_15 from "../../assets/portugal/airbnb2/9b85677f-4cc6-4477-82d2-b80dea85a52e.jpeg";
import a2_16 from "../../assets/portugal/airbnb2/a1259bf9-cd68-49d6-a4eb-63937592562a.jpeg";
import a2_17 from "../../assets/portugal/airbnb2/a59bdea0-1c7a-4e73-80de-ea286adde08c.jpeg";
import a2_18 from "../../assets/portugal/airbnb2/b43e647f-5ea6-46da-a276-cd726b7571a5.jpeg";
import a2_19 from "../../assets/portugal/airbnb2/b6c592d4-f765-4b24-968b-cc2b43a20376.jpeg";
import a2_20 from "../../assets/portugal/airbnb2/b9f0debb-ad12-4101-abb3-31f21b74d453.jpeg";
import a2_21 from "../../assets/portugal/airbnb2/ba98bafc-4cd1-41b3-9313-ecae2ebba890.jpeg";
import a2_22 from "../../assets/portugal/airbnb2/c459272c-9982-44f2-90d4-fad41962033e.jpeg";
import a2_23 from "../../assets/portugal/airbnb2/cb4a97b5-8a26-4880-9987-f1ec8ef672fd.jpeg";
import a2_24 from "../../assets/portugal/airbnb2/e58ba0d7-9b82-4ea8-9f17-4beabb17078c.jpeg";
import a2_25 from "../../assets/portugal/airbnb2/ff3bd9b7-60e7-47dc-b100-584cfb16c168.jpeg";

const AIRBNB1_URL = "https://www.airbnb.ca/rooms/1198652124922365935";
const AIRBNB2_URL = "https://www.airbnb.ca/rooms/5008897";

const airbnb1Images = [a1_01, a1_02, a1_03, a1_04, a1_05, a1_06, a1_07, a1_08, a1_09, a1_10, a1_11, a1_12, a1_13, a1_14, a1_15, a1_16, a1_17, a1_18, a1_19];
const airbnb2Images = [a2_01, a2_02, a2_03, a2_04, a2_05, a2_06, a2_07, a2_08, a2_09, a2_10, a2_11, a2_12, a2_13, a2_14, a2_15, a2_16, a2_17, a2_18, a2_19, a2_20, a2_21, a2_22, a2_23, a2_24, a2_25];

const marAltoAmenities = [
  { icon: Wifi, label: "Wifi" },
  { icon: Tv, label: "TV" },
  { icon: Wind, label: "Air conditioning" },
  { icon: Bath, label: "Hair dryer" },
  { icon: UtensilsCrossed, label: "Kitchen (oven, microwave, dishwasher)" },
  { icon: Coffee, label: "Coffee maker" },
  { icon: Shirt, label: "Washer" },
  { icon: Flame, label: "Heating" },
  { icon: Waves, label: "Steps from Pescadores & Peneco beaches" },
];

const airbnb2Amenities = [
  { icon: Mountain, label: "Scenic views · City skyline" },
  { icon: Wifi, label: "Wifi" },
  { icon: Tv, label: "TV" },
  { icon: Wind, label: "Central A/C & heating" },
  { icon: Bath, label: "Hair dryer · Cleaning products" },
  { icon: Shirt, label: "Washer & dryer in unit" },
  { icon: UtensilsCrossed, label: "Full kitchen (induction stove, oven, dishwasher)" },
  { icon: Coffee, label: "Coffee maker · Kettle" },
  { icon: Flame, label: "Dedicated workspace" },
  { icon: Baby, label: "Crib, pack ’n play, high chair, baby bath" },
];

type LightboxState = { open: false } | { open: true; images: string[]; index: number };

const StayDetails = () => {
  const [photoIndex, setPhotoIndex] = useState(0);
  const [photoIndex2, setPhotoIndex2] = useState(0);
  const [lightbox, setLightbox] = useState<LightboxState>({ open: false });

  const openLightbox = (images: string[], index: number) => setLightbox({ open: true, images, index });
  const closeLightbox = useCallback(() => setLightbox({ open: false }), []);
  const goPrev = useCallback(() => {
    setLightbox((prev) => {
      if (!prev.open) return prev;
      const next = prev.index === 0 ? prev.images.length - 1 : prev.index - 1;
      return { ...prev, index: next };
    });
  }, []);
  const goNext = useCallback(() => {
    setLightbox((prev) => {
      if (!prev.open) return prev;
      const next = prev.index === prev.images.length - 1 ? 0 : prev.index + 1;
      return { ...prev, index: next };
    });
  }, []);

  const lightboxOpen = lightbox.open;
  const lightboxIndex = lightboxOpen && "index" in lightbox ? lightbox.index : -1;
  useEffect(() => {
    if (!lightboxOpen) return;
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") closeLightbox();
      if (e.key === "ArrowLeft") goPrev();
      if (e.key === "ArrowRight") goNext();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [lightboxOpen, lightboxIndex, closeLightbox, goPrev, goNext]);

  return (
    <section className="section-padding bg-background">
      <div className="container max-w-6xl mx-auto">
        <AnimatedSection>
          <span className="text-primary font-medium tracking-widest uppercase text-sm">
            Your Stay
          </span>
          <h2 className="text-4xl md:text-5xl font-serif font-bold mt-2 mb-4">
            Stay breakdown
          </h2>
          <p className="text-muted-foreground max-w-2xl mb-12">
            May 17 at Atlantic Bliss (one night). May 18–22 at MarAlto in Albufeira. May 22–27 at the second Airbnb below.
          </p>
        </AnimatedSection>

        {/* Stay 1: MarAlto — May 18–22 */}
        <AnimatedSection>
          <h3 className="text-2xl md:text-3xl font-serif font-bold mb-6 flex items-center gap-2">
            <span className="text-orange-500">1.</span> Albufiera · May 18–22
          </h3>
        </AnimatedSection>
        <div className="grid md:grid-cols-2 gap-8 lg:gap-12 items-start mb-12">
          <AnimatedSection delay={0.2}>
            <div className="space-y-3">
              <motion.div
                className="relative rounded-2xl overflow-hidden shadow-lg aspect-[4/3] bg-muted"
                whileHover={{ scale: 1.01 }}
                transition={{ duration: 0.3 }}
              >
                <button
                  type="button"
                  className="absolute inset-0 w-full h-full cursor-zoom-in focus:outline-none focus:ring-2 focus:ring-primary focus:ring-inset"
                  onClick={() => openLightbox(airbnb1Images, photoIndex)}
                  aria-label="View full size"
                >
                  <AnimatePresence mode="wait">
                    <motion.img
                      key={photoIndex}
                      src={airbnb1Images[photoIndex]}
                      alt={`MarAlto Albufeira – photo ${photoIndex + 1}`}
                      className="absolute inset-0 w-full h-full object-cover pointer-events-none"
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      exit={{ opacity: 0 }}
                      transition={{ duration: 0.25 }}
                    />
                  </AnimatePresence>
                </button>
                <div className="absolute top-4 right-4 flex items-center gap-1 px-3 py-1.5 rounded-full bg-card/90 backdrop-blur-sm pointer-events-none">
                  <Star className="w-4 h-4 text-sunset fill-sunset" />
                  <span className="font-semibold text-sm">4.89</span>
                  <span className="text-xs text-muted-foreground">(53)</span>
                </div>
                {airbnb1Images.length > 1 && (
                  <>
                    <button
                      type="button"
                      onClick={(e) => { e.stopPropagation(); setPhotoIndex((i) => (i === 0 ? airbnb1Images.length - 1 : i - 1)); }}
                      className="absolute left-2 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white/90 shadow-md flex items-center justify-center hover:bg-white transition-colors z-10"
                      aria-label="Previous photo"
                    >
                      <ChevronLeft className="w-5 h-5" />
                    </button>
                    <button
                      type="button"
                      onClick={(e) => { e.stopPropagation(); setPhotoIndex((i) => (i === airbnb1Images.length - 1 ? 0 : i + 1)); }}
                      className="absolute right-2 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white/90 shadow-md flex items-center justify-center hover:bg-white transition-colors z-10"
                      aria-label="Next photo"
                    >
                      <ChevronRight className="w-5 h-5" />
                    </button>
                  </>
                )}
              </motion.div>
              
              <a
                href={AIRBNB1_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-2 py-2.5 px-4 rounded-xl bg-muted hover:bg-muted/80 font-semibold text-sm transition-colors"
              >
                View full listing & all photos
                <ExternalLink className="w-4 h-4" />
              </a>
            </div>
          </AnimatedSection>

          <AnimatedSection delay={0.4}>
            <div className="space-y-6">
              <div className="flex items-center gap-2 flex-wrap">
                <span className="px-2.5 py-1 rounded-full bg-orange-100 text-orange-700 text-xs font-bold uppercase tracking-wider">
                  May 18 – May 22
                </span>
                <span className="text-sm text-muted-foreground">4 nights · 6 guests · 2 bedrooms · 1.5 baths</span>
              </div>

              <div className="glass-card rounded-2xl p-6">
                <h3 className="text-xl font-serif font-semibold mb-1">
                  MarAlto in the heart of the historic center
                </h3>
                <p className="text-xs text-muted-foreground mb-3">Entire rental unit · Albufeira · Hosted by Sunny (Superhost)</p>
                <p className="flex items-start gap-2 text-sm mb-3">
                  <MapPin className="w-4 h-4 shrink-0 mt-0.5 text-primary" />
                  <a
                    href="https://www.google.com/maps?q=Rua%20Joaquim%20Pedro%20Samora%2026%2C%20Albufeira%2C%20Faro%208200-210"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-primary hover:underline"
                  >
                    Rua Joaquim Pedro Samora 26, Albufeira, Faro 8200-210
                  </a>
                </p>
                <p className="text-muted-foreground leading-relaxed text-sm">
                  Wonderful beaches nearby, markets, restaurants and bars nearby. This charming, fully renovated apartment is fully equipped with everything you could want. Sophisticated design and personalized facilities in every detail — perfect for traveling together in the Algarve, with room for up to 6 people. Small terrace with table and chairs and two sun loungers. Steps from Pescadores and Peneco beaches.
                </p>
                <a
                  href={AIRBNB1_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-primary font-semibold hover:underline mt-2 text-sm"
                >
                  Open Airbnb listing
                  <ExternalLink className="w-4 h-4" />
                </a>
              </div>

              {/* Where you'll sleep */}
              <div className="rounded-xl border border-border/70 p-4">
                <p className="text-xs font-bold uppercase tracking-wider text-muted-foreground mb-3">Where you'll sleep</p>
                <ul className="space-y-2 text-sm">
                  <li><strong>Bedroom 1</strong> — 2 single beds</li>
                  <li><strong>Bedroom 2</strong> — 1 double bed</li>
                  <li><strong>Living room</strong> — 1 sofa bed</li>
                </ul>
              </div>

              <div className="grid grid-cols-2 gap-3">
                {marAltoAmenities.map((amenity, index) => (
                  <motion.div
                    key={amenity.label}
                    initial={{ opacity: 0, scale: 0.98 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    transition={{ delay: index * 0.05 }}
                    className="flex items-center gap-2 p-3 rounded-xl bg-secondary/50"
                  >
                    <div className="p-1.5 rounded-lg bg-ocean-light shrink-0">
                      <amenity.icon className="w-4 h-4 text-ocean" />
                    </div>
                    <span className="font-medium text-sm">{amenity.label}</span>
                  </motion.div>
                ))}
              </div>

              <div className="flex items-center justify-between p-4 rounded-xl bg-coral-light border border-primary/20">
                <div>
                  <p className="text-sm text-muted-foreground">Check-in</p>
                  <p className="font-semibold">May 18 · after 4:00 PM</p>
                </div>
                <div className="w-px h-12 bg-border" />
                <div>
                  <p className="text-sm text-muted-foreground">Check-out</p>
                  <p className="font-semibold">May 22 · before 10:00 AM</p>
                </div>
              </div>
            </div>
          </AnimatedSection>
        </div>

        {/* Stay 2: May 22–27 */}
        <AnimatedSection>
          <h3 className="text-2xl md:text-3xl font-serif font-bold mb-6 flex items-center gap-2">
            <span className="text-teal-500">2.</span> Lisbon · May 22–27
          </h3>
        </AnimatedSection>
        <div className="grid md:grid-cols-2 gap-8 lg:gap-12 items-start mb-12">
          <AnimatedSection delay={0.2}>
            <div className="space-y-3">
              <motion.div
                className="relative rounded-2xl overflow-hidden shadow-lg aspect-[4/3] bg-muted"
                whileHover={{ scale: 1.01 }}
                transition={{ duration: 0.3 }}
              >
                <button
                  type="button"
                  className="absolute inset-0 w-full h-full cursor-zoom-in focus:outline-none focus:ring-2 focus:ring-primary focus:ring-inset"
                  onClick={() => openLightbox(airbnb2Images, photoIndex2)}
                  aria-label="View full size"
                >
                  <AnimatePresence mode="wait">
                    <motion.img
                      key={photoIndex2}
                      src={airbnb2Images[photoIndex2]}
                      alt={`Stay May 22–27 – photo ${photoIndex2 + 1}`}
                      className="absolute inset-0 w-full h-full object-cover pointer-events-none"
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      exit={{ opacity: 0 }}
                      transition={{ duration: 0.25 }}
                    />
                  </AnimatePresence>
                </button>
                {airbnb2Images.length > 1 && (
                  <>
                    <button
                      type="button"
                      onClick={(e) => { e.stopPropagation(); setPhotoIndex2((i) => (i === 0 ? airbnb2Images.length - 1 : i - 1)); }}
                      className="absolute left-2 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white/90 shadow-md flex items-center justify-center hover:bg-white transition-colors z-10"
                      aria-label="Previous photo"
                    >
                      <ChevronLeft className="w-5 h-5" />
                    </button>
                    <button
                      type="button"
                      onClick={(e) => { e.stopPropagation(); setPhotoIndex2((i) => (i === airbnb2Images.length - 1 ? 0 : i + 1)); }}
                      className="absolute right-2 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white/90 shadow-md flex items-center justify-center hover:bg-white transition-colors z-10"
                      aria-label="Next photo"
                    >
                      <ChevronRight className="w-5 h-5" />
                    </button>
                  </>
                )}
              </motion.div>

              <a
                href={AIRBNB2_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-2 py-2.5 px-4 rounded-xl bg-muted hover:bg-muted/80 font-semibold text-sm transition-colors"
              >
                View full listing & all photos
                <ExternalLink className="w-4 h-4" />
              </a>
            </div>
          </AnimatedSection>

          <AnimatedSection delay={0.4}>
            <div className="space-y-6">
              <div className="flex items-center gap-2 flex-wrap">
                <span className="px-2.5 py-1 rounded-full bg-teal-100 text-teal-700 text-xs font-bold uppercase tracking-wider">
                  May 22 – May 27
                </span>
                <span className="text-sm text-muted-foreground">5 nights · 3 bedrooms · 6 beds</span>
              </div>

              <div className="glass-card rounded-2xl p-6">
                <h3 className="text-xl font-serif font-semibold mb-1">
                  Airbnb · May 22–27
                </h3>
                <p className="text-xs text-muted-foreground mb-3">Entire rental unit</p>
                <p className="flex items-start gap-2 text-sm mb-3">
                  <MapPin className="w-4 h-4 shrink-0 mt-0.5 text-primary" />
                  <a
                    href="https://www.google.com/maps?q=Rua%20Cavaleiros%2067%2C%20Lisbon%2C%20Lisbon%201100"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-primary hover:underline"
                  >
                    Rua Cavaleiros 67, Lisbon, Lisbon 1100
                  </a>
                </p>
                <p className="text-muted-foreground leading-relaxed text-sm">
                  Full apartment with city skyline views, central A/C, full kitchen with induction stove and dishwasher, in-unit washer & dryer, dedicated workspace, and family-friendly amenities (crib, pack ’n play, high chair, baby bath). Paid parking garage off premises.
                </p>
                <a
                  href={AIRBNB2_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-primary font-semibold hover:underline mt-2 text-sm"
                >
                  Open Airbnb listing
                  <ExternalLink className="w-4 h-4" />
                </a>
              </div>

              <div className="rounded-xl border border-border/70 p-4">
                <p className="text-xs font-bold uppercase tracking-wider text-muted-foreground mb-3">Where you'll sleep</p>
                <ul className="space-y-2 text-sm">
                  <li><strong>Bedroom 1</strong> — 2 single beds</li>
                  <li><strong>Bedroom 2</strong> — 1 double bed</li>
                  <li><strong>Bedroom 3</strong> — 2 single beds</li>
                </ul>
              </div>

              <div className="grid grid-cols-2 gap-3">
                {airbnb2Amenities.map((amenity, index) => (
                  <motion.div
                    key={amenity.label}
                    initial={{ opacity: 0, scale: 0.98 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    transition={{ delay: index * 0.05 }}
                    className="flex items-center gap-2 p-3 rounded-xl bg-secondary/50"
                  >
                    <div className="p-1.5 rounded-lg bg-ocean-light shrink-0">
                      <amenity.icon className="w-4 h-4 text-ocean" />
                    </div>
                    <span className="font-medium text-sm">{amenity.label}</span>
                  </motion.div>
                ))}
              </div>

              <div className="flex items-center justify-between p-4 rounded-xl bg-coral-light border border-primary/20">
                <div>
                  <p className="text-sm text-muted-foreground">Check-in</p>
                  <p className="font-semibold">May 22</p>
                </div>
                <div className="w-px h-12 bg-border" />
                <div>
                  <p className="text-sm text-muted-foreground">Check-out</p>
                  <p className="font-semibold">May 27</p>
                </div>
              </div>
            </div>
          </AnimatedSection>
        </div>

        {/* Full-size image lightbox */}
        <AnimatePresence>
          {lightbox.open && (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              className="fixed inset-0 z-50 bg-black/95 flex items-center justify-center p-4"
              onClick={closeLightbox}
              role="dialog"
              aria-modal="true"
              aria-label="Image gallery"
            >
              <button
                type="button"
                onClick={closeLightbox}
                className="absolute top-4 right-4 z-10 w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center text-white transition-colors"
                aria-label="Close"
              >
                <X className="w-6 h-6" />
              </button>
              <span className="absolute top-4 left-1/2 -translate-x-1/2 z-10 text-white/90 text-sm font-medium">
                {lightbox.index + 1} / {lightbox.images.length}
              </span>
              <button
                type="button"
                onClick={(e) => { e.stopPropagation(); goPrev(); }}
                className="absolute left-4 top-1/2 -translate-y-1/2 z-10 w-12 h-12 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center text-white transition-colors"
                aria-label="Previous image"
              >
                <ChevronLeft className="w-7 h-7" />
              </button>
              <motion.img
                key={lightbox.index}
                src={lightbox.images[lightbox.index]}
                alt=""
                className="max-w-[100vw] max-h-[100vh] w-auto h-auto object-contain"
                style={{ maxHeight: "100dvh", maxWidth: "100vw" }}
                initial={{ opacity: 0, scale: 0.98 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.2 }}
                onClick={(e) => e.stopPropagation()}
              />
              <button
                type="button"
                onClick={(e) => { e.stopPropagation(); goNext(); }}
                className="absolute right-4 top-1/2 -translate-y-1/2 z-10 w-12 h-12 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center text-white transition-colors"
                aria-label="Next image"
              >
                <ChevronRight className="w-7 h-7" />
              </button>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </section>
  );
};

export default StayDetails;
